import React from 'react';
import PropTypes from 'prop-types';
import { Table, Checkbox, Icon, Popup } from 'semantic-ui-react';
import _ from 'lodash';

import ConditionalTableElement, {
  shouldRenderSocialTableColumn,
} from '../../components/conditional-table-element/index';

import { TiktokIcon } from '../../components/dyzio-icons';

const matchSorting = s => _.lowerCase(s).concat('ending');


const InfluencerTableHeaderRow = props => {
  const { columnsSettings, sorting } = props;
  const { field, order } = sorting;

  const sortedName = field === 'name' ? matchSorting(order) : null;
  const sortedCountry = field === 'country' ? matchSorting(order) : null;
  const sortedFacebook = field === 'facebookCount' ? matchSorting(order) : null;
  const sortedYoutube = field === 'youtubeCount' ? matchSorting(order) : null;
  const sortedInstagram = field === 'instagramCount' ? matchSorting(order) : null;
  const sortedTwitter = field === 'twitterCount' ? matchSorting(order) : null;
  const sortedCreatedDate = field === 'createdDate' ? matchSorting(order) : null;
  const sortedTwitch = field === 'twitchCount' ? matchSorting(order) : null;
  const sortedTiktok = field === 'tiktokCount' ? matchSorting(order) : null;
  const instagramEngagementRateSorted = field === 'instagramEngagementRate' ? matchSorting(order) : null;

  return (
    <Table.Row>
      <Table.HeaderCell
        verticalAlign="middle"
        textAlign="center"
        width={1}
      >
        <Checkbox onChange={props.onCheckAll} />
      </Table.HeaderCell>
      <Table.HeaderCell
        width={4}
        onClick={() => props.onSort('name', sortedName)}
        sorted={sortedName}
      >
            Influencer
      </Table.HeaderCell>
      <Table.HeaderCell
        width={1}
        onClick={() => props.onSort('country', sortedCountry)}
        sorted={sortedCountry}
        textAlign="center"
      >
        <Popup
          trigger={<Icon name="flag outline" />}
          content="Influencer country"
        />
      </Table.HeaderCell>

      <Table.HeaderCell
        width={1}
        textAlign="center"
      >
        <Popup
          trigger={<Icon name="briefcase" />}
          content="is Instagram Business Account?"
        />
      </Table.HeaderCell>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'instagram_engagement_rate')}>
        <Table.HeaderCell
          textAlign="center"
          width={1}
          onClick={() => props.onSort('instagramEngagementRate', instagramEngagementRateSorted)}
          sorted={instagramEngagementRateSorted}
        >
          <Popup
            trigger={<Icon name="percent" color="pink" />}
            content="Instagram Engagement Rate"
          />
        </Table.HeaderCell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'facebook')}>
        <Table.HeaderCell
          textAlign="center"
          width={1}
          onClick={() => props.onSort('facebookCount', sortedFacebook)}
          sorted={sortedFacebook}
        >
          <img src="/icons/facebook.svg" alt="Facebook" />
        </Table.HeaderCell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'instagram')}>
        <Table.HeaderCell
          width={1}
          textAlign="center"
          onClick={() => props.onSort('instagramCount', sortedInstagram)}
          sorted={sortedInstagram}
        >
          <img src="/icons/instagram.svg" alt="Instagram" />
        </Table.HeaderCell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'twitter')}>
        <Table.HeaderCell
          textAlign="center"
          width={1}
          onClick={() => props.onSort('twitterCount', sortedTwitter)}
          sorted={sortedTwitter}
        >
          <img src="/icons/twitter.svg" alt="Twitter" />
        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'youtube')}>
        <Table.HeaderCell
          textAlign="center"
          width={1}
          onClick={() => props.onSort('youtubeCount', sortedYoutube)}
          sorted={sortedYoutube}
        >
          <img src="/icons/youtube.svg" alt="YouTube" />
        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'website')}>
        <Table.HeaderCell
          width={1}
          textAlign="center"
        >
          <Popup
            trigger={<Icon name="world" color="blue" />}
            content="Website or blog URL"
          />

        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'snapchat')}>
        <Table.HeaderCell
          width={1}
          textAlign="center"
        >
          <Popup
            trigger={<Icon name="snapchat ghost" color="yellow" />}
            content="Snapchat handle"
          />

        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'telegram')}>
        <Table.HeaderCell
          width={1}
          textAlign="center"
        >
          <Popup
            trigger={<Icon name="telegram" size="large" color="blue" />}
            content="Telegram User (channel counts)"
          />

        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'twitch')}>
        <Table.HeaderCell
          width={1}
          onClick={() => props.onSort('twitchCount', sortedTwitch)}
          sorted={sortedTwitch}
          textAlign="center"
        >
          <Popup
            trigger={<Icon name="twitch" color="purple" />}
            content="Twitch follower count"
          />

        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'tiktok')}>
        <Table.HeaderCell
          width={1}
          onClick={() => props.onSort('tiktokCount', sortedTiktok)}
          sorted={sortedTiktok}
          textAlign="center"
        >
          <Popup
            trigger={<TiktokIcon />}
            content="Tiktok follower count"
          />

        </Table.HeaderCell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'linkedin')}>
        <Table.HeaderCell
          width={1.5}
          textAlign="center"
        >
          <Popup
            trigger={<Icon name="linkedin" color="blue" />}
            content="Linkedin handle"
          />

        </Table.HeaderCell>
      </ConditionalTableElement>

      <Table.HeaderCell
        onClick={() => props.onSort('createdDate', sortedCreatedDate)}
        width={2}
        sorted={sortedCreatedDate}
        textAlign="center"
      >
        <Popup
          trigger={<Icon name="checked calendar" />}
          content="The date the influencer was added to your database."
        />

      </Table.HeaderCell>
    </Table.Row>
  );
};


InfluencerTableHeaderRow.propTypes = {
  onCheckAll: PropTypes.func.isRequired,
  onSort: PropTypes.func.isRequired,
  sorting: PropTypes.object.isRequired,
  columnsSettings: PropTypes.object.isRequired,
};

export default InfluencerTableHeaderRow;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-table-header-row/index.js
 **/